import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom';
//react-admin
import { useTranslate, List, useListContext, useListPaginationContext, PaginationActions, useLocaleState, useDelete, useNotify, usePermissions } from 'react-admin'
// ticatag
import { LocationsMap } from '../../ui/maps/map'
import LocationHistoryActions from './actions'
import { useParams } from 'react-router-dom';
import { deviceName } from '../../rest/restClient';
import { listMapCommonStyle } from '../../themes/commonStyles'
import { Box, Typography, ListSubheader, ListItemButton, ListItem, IconButton, useTheme, useMediaQuery, TablePagination, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, CircularProgress } from '@mui/material'
import { OptionsBtn } from '../../ui/button/OptionsBtn'
import PageHeader from '../../ui/layout/PageHeader'
import LoadingDialog from '../../ui/dialog/LoadingDialog'
import NavigateBackBtn from '../../ui/button/NavigateBackBtn'
import { PDF_REPORT_LOCATION_HISTORY } from '../configuration/actions';
import StandardDialog from '../../ui/dialog/StandardDialog';
import { getDateTimeToFullLocalString } from '../../utils/date';
import { coordinatesToDMS } from '../../utils/coordinateConverter';
import { isSuperAdmin } from '../../helper/resourceHelper';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import IconCancel from '@mui/icons-material/Cancel';
import { alpha } from '@mui/material/styles';










const MenuCustomListSubheader = ({
}) => {
    const theme = useTheme();
    const translate = useTranslate();
    const notify = useNotify();
    const navigate = useNavigate();
    const { id } = useParams();
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [deleteRecord] = useDelete();

    const handleDeleteClick = useCallback(() => {
        setShowDeleteDialog(true);
    }, []);

    const handleDeleteConfirm = useCallback(() => {
        setIsDeleting(true);
        deleteRecord(
            'location_events',
            { id: `/all/device_id/${id}` },
            {
                mutationMode: 'pessimistic',
                onSuccess: () => {
                    setIsDeleting(false);
                    notify(translate('resources.common.delete_history_success'), { type: 'info' });
                    setShowDeleteDialog(false);
                    navigate('/devices');
                },
                onError: () => {
                    setIsDeleting(false);
                    notify(translate('resources.common.delete_history_error'), { type: 'error' });
                }
            }
        );
    }, [deleteRecord, id, notify, translate, navigate]);

    const handleDeleteCancel = useCallback(() => {
        setShowDeleteDialog(false);
    }, []);

    let options = []
    options.push({
        label: translate('resources.locations.labels.exportData'),
        path: `/export/create?selectedIds=${id}&selectedEventType=location`
    })
    options.push({
        label: translate('resources.locations.labels.delete'),
        onClick: handleDeleteClick
    })


    const {
        isLoading,
        hasNextPage,
        page,
        perPage,
        total,
        setPage,
        setPerPage,
    } = useListPaginationContext();

    const totalPages = useMemo(() => {
        return total != null ? Math.ceil(total / perPage) : undefined;
    }, [perPage, total]);
    const handlePageChange = useCallback(
        (event, page) => {
            event && event.stopPropagation();
            if (page < 0 || page > totalPages - 1) {
                throw new Error(
                    translate('ra.navigation.page_out_of_boundaries', {
                        page: page + 1,
                    })
                );
            }
            setPage(page + 1);
        },
        [totalPages, setPage, translate]
    );

    const labelDisplayedRows = useCallback(
        ({ from, to, count }) =>
            count === -1 && hasNextPage
                ? translate('ra.navigation.partial_page_range_info', {
                    offsetBegin: from,
                    offsetEnd: to,
                    _: `%{from}-%{to} of more than %{to}`,
                })
                : translate('ra.navigation.page_range_info', {
                    offsetBegin: from,
                    offsetEnd: to,
                    total: count === -1 ? to : count,
                    _: `%{from}-%{to} of %{count === -1 ? to : count}`,
                }),
        [translate, hasNextPage]
    );

    const labelItem = useCallback(
        type => translate(`ra.navigation.${type}`, { _: `Go to ${type} page` }),
        [translate]
    );

    if (isLoading) {
        return null;
    }

    // Avoid rendering TablePagination if "page" value is invalid
    if (total === 0 || page < 1 || (total != null && page > totalPages)) {
        if (limit != null && process.env.NODE_ENV === 'development') {

        }
        return null;
    }

    return (
        <ListSubheader
            component="div"
            sx={{
                padding: "0px 0px 16px 0px",
                margin: "0px",
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "flex-start",
            }}>


            <Box sx={{
                padding: "0px",
                margin: "4px 0px 0px 4px",
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "flex-start",
            }}>

                <TablePagination
                    count={total == null ? -1 : total}
                    rowsPerPage={perPage}
                    rowsPerPageOptions={[]}
                    page={page - 1}
                    ActionsComponent={(rest) => <PaginationActions siblingCount={0} boundaryCount={1} color="primary"{...rest} />}
                    onPageChange={handlePageChange}
                    slotProps={{
                        actions: {
                            nextButton: { disabled: !hasNextPage }
                        }
                    }}



                    sx={{
                        width: "100%",
                        margin: "0px 0px 15px 0px",
                        display: "flex",
                        padding: "0px",
                        alignItems: "flex-start",
                        flexDirection: "row",
                        justifyContent: "center",
                        "& .MuiToolbar-root": {
                            boxShadow: "none !important",
                            flexDirection: "column",
                            margin: "0px !important",
                            padding: "0px !important",
                            "&.MuiToolbar-root.MuiTablePagination-toolbar": {
                                padding: "0px !important",
                                minHeight: "0px  !important",
                            }
                        },
                        "& .MuiTablePagination-displayedRows": {
                            margin: "0px !important",
                            fontWeight: 500
                        },
                        "& .MuiTablePagination-actions": {
                            margin: "0px !important",
                            fontSize: "10px"
                        }
                    }}
                    component="span"
                    labelRowsPerPage={""}
                    labelDisplayedRows={labelDisplayedRows}
                    getItemAriaLabel={labelItem}
                />
            </Box>
            <Box sx={{ flex: 1 }} />
            <Box sx={{
                padding: "0px",
                margin: "10px 10px 0px 0px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "flex-start",
                lineHeight: "18.75px"
            }} >

                <OptionsBtn width={"24"} height={"24"} menuItems={options} />
            </Box>

            {/* Delete Confirmation Dialog */}
            <Dialog
                fullWidth
                open={showDeleteDialog}
                onClose={isDeleting ? undefined : handleDeleteCancel}
                aria-label="Are you sure?"
            >
                <DialogTitle>
                    {translate('resources.common.delete_history')}
                </DialogTitle>
                <DialogContent>
                    {isDeleting ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 2 }}>
                            <CircularProgress size={24} sx={{ marginRight: 2 }} />
                            <Typography>{translate('resources.common.delete_history_loading')}</Typography>
                        </Box>
                    ) : (
                        <div>{translate('resources.common.delete_history_paragraph')}</div>
                    )}
                </DialogContent>
                {!isDeleting && (
                    <DialogActions>
                        <Button
                            onClick={handleDeleteConfirm}
                            sx={{
                                color: theme.palette.error.main,
                                '&:hover': {
                                    backgroundColor: alpha(theme.palette.error.main, 0.12),
                                    '@media (hover: none)': {
                                        backgroundColor: 'transparent'
                                    }
                                }
                            }}
                        >
                            <DeleteForeverIcon sx={{ marginRight: 1 }} />
                            {translate('ra.action.delete')}
                        </Button>
                        <Button onClick={handleDeleteCancel}>
                            <IconCancel sx={{ marginRight: 1 }} />
                            {translate('ra.action.cancel')}
                        </Button>
                    </DialogActions>
                )}
            </Dialog>
        </ListSubheader>
    )
}

const MenuCustomListItemNumberIcon = ({ number, color }) => {
    const theme = useTheme();
    let fontSizeText = "16px";
    if (number > 0 && number < 10) {
        fontSizeText = "16px";
    }
    if (number > 9 && number < 100) {
        fontSizeText = "16px";
    }
    if (number > 99 && number < 1000) {
        fontSizeText = "14px";
    }
    if (number > 999) {
        fontSizeText = "12px";
    }
    return (

        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="32" rx="8" fill={color} />
            {number != null && number > 0 && <g>
                <text x="50%" y="50%" font-family="Roboto" font-size={fontSizeText} dominant-baseline="middle" text-anchor="middle" font-weight="bold" fill="white">{number}</text>
            </g>}
        </svg>



    )
}


const MenuCustomListItemLocationIcon = ({ color }) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_12_39822)">
                <path d="M8.00033 5.3335C7.26699 5.3335 6.66699 5.9335 6.66699 6.66683C6.66699 7.40016 7.26699 8.00016 8.00033 8.00016C8.73366 8.00016 9.33366 7.40016 9.33366 6.66683C9.33366 5.9335 8.73366 5.3335 8.00033 5.3335ZM8.00033 1.3335C5.20033 1.3335 2.66699 3.48016 2.66699 6.80016C2.66699 9.0135 4.44699 11.6335 8.00033 14.6668C11.5537 11.6335 13.3337 9.0135 13.3337 6.80016C13.3337 3.48016 10.8003 1.3335 8.00033 1.3335ZM8.00033 12.8868C5.30033 10.4202 4.00033 8.36016 4.00033 6.7935C4.00033 4.38016 5.76699 2.66683 8.00033 2.66683C10.2337 2.66683 12.0003 4.38016 12.0003 6.80016C12.0003 8.36016 10.7003 10.4268 8.00033 12.8868Z" fill={color} />
            </g>
            <defs>
                <clipPath id="clip0_12_39822">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>


    )
}

const MenuCustomListItemDetailsIcon = ({ color }) => {
    return (

        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-info-circle">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
            <path d="M12 9h.01" />
            <path d="M11 12h1v4h1" />
        </svg>



    )
}

const MenuCustomLocationGeofenceIcon = ({ color }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M12,3V5m9,7H19m-7,9V19M3,12H5m9-1a2,2,0,0,0-4,0c0,2,2,4,2,4S14,13,14,11Z"
                style={{
                    fill: 'none',
                    stroke: 'rgb(44, 169, 188)',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeWidth: 2,
                }}
            />
            <circle
                cx="12"
                cy="12"
                r="7"
                style={{
                    fill: 'none',
                    stroke: color || 'black',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeWidth: 2,
                }}
            />
        </svg>
    );
};

const MenuCustomListItemSpeedIcon = ({ color }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-brand-speedtest">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M5.636 19.364a9 9 0 1 1 12.728 0" />
            <path d="M16 9l-4 4" />
        </svg>


    )
}

const MenuCustomListItemAltitudeIcon = ({ color }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-alt"><path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M4 16v-6a2 2 0 1 1 4 0v6" />
            <path d="M4 13h4" />
            <path d="M11 8v8h4" />
            <path d="M16 8h4" />
            <path d="M18 8v8" />
        </svg>


    )
}

const MenuCustomListItemDateTimeIcon = ({ color }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-clock">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" stroke-width="1" />
            <path d="M3 12a9 9 0 1 0 18 0 9 9 0 0 0 -18 0" />
            <path d="M12 7V12l3 3" />
        </svg>


    )
}


const MenuCustomListItemAccuracyIcon = ({ color }) => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-gradienter">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M3.227 14c.917 4 4.497 7 8.773 7c4.277 0 7.858 -3 8.773 -7" />
            <path d="M20.78 10a9 9 0 0 0 -8.78 -7a8.985 8.985 0 0 0 -8.782 7" />
            <path d="M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
        </svg>
    )
}

const MenuCustomListItemCloseIcon = ({ color }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-x">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M18 6l-12 12" />
            <path d="M6 6l12 12" />
        </svg>
    )
}






const MenuCustomListItemSatelliteIcon = ({ color }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-satellite">
            <path stroke="none" d="M0 0h16v16H0z" fill="none" strokeWidth="0.6666666666666666" />
            <path d="m2.471 4.195 1.724 -1.724a0.667 0.667 0 0 1 0.943 0l3.724 3.724a0.667 0.667 0 0 1 0 0.943l-1.724 1.724a0.667 0.667 0 0 1 -0.943 0L2.471 5.138a0.667 0.667 0 0 1 0 -0.943" />
            <path d="m4 6.667 -2 2 2 2 2 -2" />
            <path d="m6.667 4 2 -2 2 2 -2 2" />
            <path d="m8 8 1 1" />
            <path d="M9.667 11.333a1.667 1.667 0 0 0 1.667 -1.667" />
            <path d="M10 14a4 4 0 0 0 4 -4" /></svg>


    )
}

const MenuCustomListItemAntennaIcon = ({ color }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 486.576 486.576"
            fill={color}
            className="icon icon-antenna"
        >
            <g>
                <path d="M130.151,247.487c-62.384-62.384-62.384-163.89,0-226.274L108.938,0c-74.081,74.081-74.081,194.619,0,268.7 L130.151,247.487z" />
                <path d="M356.425,247.487l21.213,21.213c74.081-74.081,74.081-194.619,0-268.7l-21.213,21.213 C418.809,83.597,418.809,185.103,356.425,247.487z" />
                <path d="M158.436,219.203l21.213-21.213c-16.967-16.967-26.312-39.568-26.312-63.64s9.344-46.672,26.312-63.64l-21.213-21.213 c-22.634,22.633-35.099,52.768-35.099,84.853S135.802,196.569,158.436,219.203z" />
                <path d="M328.141,219.203c22.634-22.633,35.099-52.768,35.099-84.853s-12.465-62.219-35.099-84.853L306.928,70.71 c16.967,16.967,26.312,39.568,26.312,63.64s-9.344,46.672-26.312,63.64L328.141,219.203z" />
                <path d="M262.19,180.629c18.224-7.471,31.099-25.395,31.099-46.279c0-27.57-22.43-50-50-50s-50,22.43-50,50 c0,20.883,12.874,38.808,31.098,46.279l-80.258,275.948H85.387v30h315.794v-30H342.44L262.19,180.629z M281.879,355.762 l-77.188,0.007l38.597-132.705L281.879,355.762z M243.288,114.35c11.028,0,20,8.972,20,20s-8.972,20-20,20s-20-8.972-20-20 S232.26,114.35,243.288,114.35z M195.965,385.77l94.638-0.008l20.594,70.815H175.371L195.965,385.77z" />
            </g>
        </svg>
    )
}
const MenuCustomListItemIbuttonIcon = ({ color }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
         viewBox="0 0 24 24" fill="none" stroke={color}
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    
      <rect x="5" y="4" width="14" height="16" rx="2" />
      <circle cx="12" cy="10" r="2" />
      <path d="M9 15h6" />
    </svg>
  );

const MenuCustomListItemParentDeviceIcon = ({ color }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            
            <rect x="5" y="5" width="14" height="14" rx="2" />
            <rect x="9" y="9" width="6" height="6" rx="1" />
            <path d="M9 3v2" />
            <path d="M15 3v2" />
            <path d="M9 19v2" />
            <path d="M15 19v2" />
            <path d="M3 9h2" />
            <path d="M3 15h2" />
            <path d="M19 9h2" />
            <path d="M19 15h2" />
        </svg>
    )
}

const MenuCustomListItemCloseBtn = ({ onClick, color }) => {
    return (
        <IconButton
            onClick={(e) => {
                e.preventDefault();
                onClick();
            }}
        >
            <MenuCustomListItemCloseIcon color={color} />
        </IconButton>

    )
}




const MenuCustomListItemDetailsBtn = ({ onClick, color }) => {
    const translate = new useTranslate();
    return (
        <Tooltip title={translate('resources.common.view_more')} disableInteractive>
        <IconButton
            onClick={(e) => {
                e.preventDefault();
                onClick();
            }}
        >

            <MenuCustomListItemDetailsIcon color={color} />
        </IconButton>
        </Tooltip>

    )
}

const MenuCustomListItemCreateAlertButton = ({ record }) => {
    const navigate = useNavigate();
    const translate = useTranslate();
    const theme = useTheme();

    const handleClick = (e) => {
        e.preventDefault();
        navigate('/notifications/create', {
            state: {
                fromLocationHistory: true,
                device_id: record.device_id,
                latitude: record.latitude,
                longitude: record.longitude,
                formatted_address: record.formatted_address,
            },
        });
    };

    return (
        <Tooltip title={translate('resources.geofences.create')} disableInteractive>
            <IconButton
                sx={{ padding: 0, margin: 0, minWidth: 0 }}
                onClick={handleClick}
            >
                <MenuCustomLocationGeofenceIcon color={theme.palette.primary.main} />
            </IconButton>
        </Tooltip>
    );
};

const MenuCustomListItem = React.memo(({ location, number, theme, handleSelect, selected, isMobile, isListAsDialog }) => {
    const [openDetails, setOpenDetails] = useState(false);
    const [locale, setLocale] = useLocaleState();
    const record = location.record;
    const maxFormattedAddressCharacters = isListAsDialog ? 70 : 25

    // Memoize computed values to avoid recalculation on every render
    const dateTimeText = useMemo(() => {
        return record.timestamp ? getDateTimeToFullLocalString({ timestamp: record.timestamp, locale }) : null;
    }, [record.timestamp, locale]);

    const formattedAddressText = useMemo(() => {
        if (!record.formatted_address) return null;
        return record.formatted_address.length > maxFormattedAddressCharacters 
            ? `${record.formatted_address.substring(0, maxFormattedAddressCharacters - 1)}...` 
            : record.formatted_address;
    }, [record.formatted_address, maxFormattedAddressCharacters]);

    const locationText = useMemo(() => {
        return (record.latitude && record.longitude && !record.formatted_address) 
            ? `${record.latitude}, ${record.longitude}` 
            : null;
    }, [record.latitude, record.longitude, record.formatted_address]);


    if (dateTimeText == null && locationText == null) {
        return null
    }
    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: "100%" }}>
            <ListItemButton
                id={`menu-custom-list-item-${record.id}`}
                button
                onClick={() => {
                    handleSelect(location)
                }}
                sx={{
                    backgroundColor: selected ? theme.palette.primary.light : theme.palette.background.paper,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    padding: "12px 2px 12px 12px",
                    margin: "0px",
                    borderRadius: isMobile ? "12px" : 0
                }} >
                <MenuCustomListItemNumberIcon number={number} color={theme.palette.primary.main} />
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    padding: "0px",
                    margin: "0px 10px 0px 10px"
                }}>

                    <Typography sx={{ color: theme.palette.text.primary, fontSize: "14px", fontWeight: 500, lineHeight: "20px", fontFamily: "Roboto", textAlign: "left", alignmentBaseline: "central", margin: "0px 0px 5px 0px", padding: "0px" }} >{dateTimeText}</Typography>



                    {formattedAddressText &&
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'flex-start',
                                alignItems: 'center',
                                padding: "0px",
                                margin: "0px"
                            }}>
                            <MenuCustomListItemLocationIcon color={theme.palette.text.secondary} />
                            <Typography sx={{ color: theme.palette.text.secondary, fontSize: "12px", fontWeight: 400, lineHeight: "20px", fontFamily: "Roboto", textAlign: "left", margin: "2px 0px 2px 5px", padding: "0px" }} >{formattedAddressText}</Typography>

                        </Box>
                    }

                    {!formattedAddressText && locationText &&
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'flex-start',
                                alignItems: 'center',
                                padding: "0px",
                                margin: "0px"
                            }}>
                            <MenuCustomListItemSatelliteIcon color={theme.palette.text.secondary} />
                            <Typography sx={{ color: theme.palette.text.secondary, fontSize: "12px", fontWeight: 400, lineHeight: "20px", fontFamily: "Roboto", textAlign: "left", margin: "2px 0px 2px 5px", padding: "0px" }} >{locationText}</Typography>

                        </Box>
                    }




                </Box>
                <Box sx={{ flex: 1 }} />
            </ListItemButton>
            <Box sx={{ flex: 1 }} />
                <Box sx={{ margin: "0px 10px", display: "flex", flexDirection: "column", alignItems: "center", gap: 0 }} >
                    <MenuCustomListItemCreateAlertButton record={record} />
                    <MenuCustomListItemDetailsBtn color={theme.palette.primary.main} onClick={() => setOpenDetails(true)} />
                    <StandardDialog
                        fullWidth={false}
                        open={openDetails}
                        onClose={() => setOpenDetails(false)}
                        BodyComponent={() =>
                            <MenuCustomListItemDetails
                                location={location}
                                number={number}
                                theme={theme}
                                onClose={() => setOpenDetails(false)}
                            />} />
                </Box>      
        </Box>
    )

});

const MenuCustomListItemDetails = React.memo(({ location, number, theme, onClose }) => {
    const [locale, setLocale] = useLocaleState();
    const translate = useTranslate();
    const navigate = useNavigate();
    const { permissions } = usePermissions();
    const record = location.record;

    // Memoize all computed values
    const dateTimeText = useMemo(() => 
        record.timestamp ? getDateTimeToFullLocalString({ timestamp: record.timestamp, locale }) : null,
        [record.timestamp, locale]
    );

    const formattedAddressText = useMemo(() => 
        record.formatted_address || null,
        [record.formatted_address]
    );

    const locationText = useMemo(() => {
        if (!record.latitude || !record.longitude) return null;
        const dms = coordinatesToDMS(record.latitude, record.longitude);
        return `${record.latitude}, ${record.longitude}\n${dms.lat}, ${dms.lng}`;
    }, [record.latitude, record.longitude]);

    const positioningTypeText = useMemo(() =>
        record.positioning_system ? translate(`resources.measures.positioning_system_${record.positioning_system}`) : null,
        [record.positioning_system, translate]
    );

    const macAddressText = useMemo(() =>
        (isSuperAdmin(permissions) && record.positioning_system === 'wifi_sniffing' && record.mac_address) ? record.mac_address : null,
        [permissions, record.positioning_system, record.mac_address]
    );

    const ibuttonSNText = useMemo(
        () => (record.ibutton_serial_number ? `${record.ibutton_serial_number}` : null),
        [record.ibutton_serial_number]
    );

    const parentDeviceSNText = useMemo(
        () => (record.parent_device_serial_number ? `${record.parent_device_serial_number}` : null),
        [record.parent_device_serial_number]
    );

    const altitudeText = useMemo(() => 
        record.altitude ? `${record.altitude} m` : null,
        [record.altitude]
    );

    const speedText = useMemo(() => 
        record.speed ? `${record.speed} km/h` : null,
        [record.speed]
    );

    const accuracyText = useMemo(() => 
        record.accuracy ? `${record.accuracy} m` : null,
        [record.accuracy]
    );
    
    const handleNavigateToDeviceBySerial = useCallback(
        (serial) => {
            if (!serial) return;
            const filter = encodeURIComponent(JSON.stringify({ q: serial }));
            const displayedFilters = encodeURIComponent(JSON.stringify({}));
            navigate(
                `/devices?displayedFilters=${displayedFilters}&filter=${filter}` +
                `&order=DESC&page=1&perPage=25&sort=last_seen`
            );
        },
        [navigate]
    );

    const handleNavigateToMacAddress = useCallback(
        (mac) => {
            if (!mac) return;
            navigate(`/mac_addresses?mac_address=${encodeURIComponent(mac)}`);
        },
        [navigate]
    );
    return <ListItem
        sx={{
            backgroundColor: theme.palette.background.paper,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            padding: "0px",
            margin: "0px",
            width: "100%"
        }} >
        <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: "0px",
            margin: "0px",
            width: "100%"
        }}>

            <MenuCustomListItemNumberIcon number={number} color={theme.palette.primary.main} />
            <Typography sx={{ color: theme.palette.text.primary, fontSize: "20px", fontWeight: 500, lineHeight: "20px", fontFamily: "Roboto", textAlign: "left", alignmentBaseline: "central", margin: "0px 120px 0px 10px", padding: "0px" }} >{translate("ra.message.details")}</Typography>
            <MenuCustomListItemCloseBtn onClick={onClose} color={theme.palette.text.secondary} />


        </Box>
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            padding: "0px",
            margin: "20px 10px 0px 10px"
        }}>

            {dateTimeText &&
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        padding: "0px",
                        margin: "0px 0px 8px 0px"
                    }}>
                    <MenuCustomListItemDateTimeIcon color={theme.palette.text.primary} />
                    <Typography sx={{ color: theme.palette.text.primary, fontSize: "16px", fontWeight: 500, lineHeight: "20px", fontFamily: "Roboto", textAlign: "left", alignmentBaseline: "central", margin: "6px 0px 8px 5px", padding: "0px" }} >{dateTimeText}</Typography>

                </Box>
            }


            {formattedAddressText &&
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        padding: "0px",
                        margin: "0px 0px 5px 3px"
                    }}>
                    <MenuCustomListItemLocationIcon color={theme.palette.text.secondary} />
                    <Typography sx={{ color: theme.palette.text.secondary, fontSize: "12px", fontWeight: 400, lineHeight: "20px", fontFamily: "Roboto", textAlign: "left", margin: "8px 0px 8px 5px", padding: "0px", width: "80%" }} >{formattedAddressText}</Typography>

                </Box>}

            {locationText &&
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        padding: "0px",
                        margin: "0px 0px 0px 5px"
                    }}>
                    <MenuCustomListItemSatelliteIcon color={theme.palette.text.secondary} />
                    <Typography sx={{ color: theme.palette.text.secondary, fontSize: "12px", fontWeight: 400, lineHeight: "20px", fontFamily: "Roboto", textAlign: "left", margin: "8px 0px 8px 5px", padding: "0px", whiteSpace: "pre-line" }} >{locationText}</Typography>

                </Box>
            }

            {ibuttonSNText &&
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        padding: "0px",
                        margin: "0px 0px 0px 5px"
                    }}>
                    <MenuCustomListItemIbuttonIcon color={theme.palette.primary.main} />
                    <Typography
                        sx={{
                            color: theme.palette.primary.main,
                            fontSize: "12px",
                            fontWeight: 400,
                            lineHeight: "20px",
                            fontFamily: "Roboto",
                            textAlign: "left",
                            margin: "8px 0px 8px 5px",
                            padding: "0px",
                            cursor: "pointer",
                            textDecoration: "underline",
                        }}
                        onClick={() => handleNavigateToDeviceBySerial(record.ibutton_serial_number)}
                    >
                        {ibuttonSNText}
                    </Typography>

                </Box>
            }

            {parentDeviceSNText &&
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        padding: "0px",
                        margin: "0px 0px 0px 5px"
                    }}>
                    <MenuCustomListItemParentDeviceIcon color={theme.palette.primary.main} />
                    <Typography
                        sx={{
                            color: theme.palette.primary.main,
                            fontSize: "12px",
                            fontWeight: 400,
                            lineHeight: "20px",
                            fontFamily: "Roboto",
                            textAlign: "left",
                            margin: "8px 0px 8px 5px",
                            padding: "0px",
                            cursor: "pointer",
                            textDecoration: "underline",
                        }}
                        onClick={() => handleNavigateToDeviceBySerial(record.parent_device_serial_number)}
                    >
                        {parentDeviceSNText}
                    </Typography>

                </Box>
            }

            {altitudeText &&
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        padding: "0px",
                        margin: "0px 0px 0px 5px"
                    }}>
                    <MenuCustomListItemAltitudeIcon color={theme.palette.text.secondary} />
                    <Typography sx={{ color: theme.palette.text.secondary, fontSize: "12px", fontWeight: 400, lineHeight: "20px", fontFamily: "Roboto", textAlign: "left", margin: "8px 0px 8px 5px", padding: "0px" }} >{altitudeText}</Typography>

                </Box>
            }


            {
                accuracyText &&
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        padding: "0px",
                        margin: "0px 0px 0px 5px"
                    }}>
                    <MenuCustomListItemAccuracyIcon color={theme.palette.text.secondary} />
                    <Typography sx={{ color: theme.palette.text.secondary, fontSize: "12px", fontWeight: 400, lineHeight: "20px", fontFamily: "Roboto", textAlign: "left", margin: "8px 0px 8px 5px", padding: "0px" }} >{accuracyText}</Typography>

                </Box>
            }

            {speedText &&
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        padding: "0px",
                        margin: "0px 0px 0px 5px"
                    }}>
                    <MenuCustomListItemSpeedIcon color={theme.palette.text.secondary} />
                    <Typography sx={{ color: theme.palette.text.secondary, fontSize: "12px", fontWeight: 400, lineHeight: "20px", fontFamily: "Roboto", textAlign: "left", margin: "8px 0px 8px 5px", padding: "0px" }} >{speedText}</Typography>

                </Box>
            }

            {positioningTypeText &&
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        padding: "0px",
                        margin: "0px 0px 0px 5px"
                    }}>
                    <MenuCustomListItemAntennaIcon color={theme.palette.text.secondary} />
                    <Typography sx={{ color: theme.palette.text.secondary, fontSize: "12px", fontWeight: 400, lineHeight: "20px", fontFamily: "Roboto", textAlign: "left", margin: "8px 0px 8px 5px", padding: "0px" }} >{positioningTypeText}</Typography>
                    {macAddressText &&
                        <Typography
                            sx={{
                                color: theme.palette.primary.main,
                                fontSize: "12px",
                                fontWeight: 400,
                                lineHeight: "20px",
                                fontFamily: "Roboto",
                                textAlign: "left",
                                margin: "8px 0px 8px 5px",
                                padding: "0px",
                                cursor: "pointer",
                                textDecoration: "underline",
                            }}
                            onClick={() => handleNavigateToMacAddress(macAddressText)}
                        >
                            {`(${macAddressText})`}
                        </Typography>
                    }

                </Box>
            }


        </Box>
    </ListItem>
});


const LoadingPopUp = ({ }) => {
    const { isPending, isFetching, isLoading } = useListContext();
    return (
        <LoadingDialog
            isPending={isPending}
            isFetching={isFetching}
            isLoading={isLoading}
        />
    )

};



const LocationHistoryList = ({ ...props }) => {


    const { id } = useParams()
    const [_deviceName, setDeviceName] = useState('');
    const [deviceSN, setDeviceSN] = useState('');
    const theme = useTheme()
    const translate = useTranslate();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {

        deviceName(id).then(event => {
            setDeviceName(event.json.name)
            setDeviceSN(event.json.serial_number ? event.json.serial_number : event.json.mac_address)
        })

    }, [id])


    return (
        <Box>
            <Typography sx={{ color: theme.palette.text.primary, textAlign: 'start', fontWeight: 700, fontSize: "24px", lineHeight: "42px", margin: "0px 0px 2px 0px" }}>
                <NavigateBackBtn /> {translate('resources.devices.labels.locationsHistory')}
            </Typography>
            {
                !isMobile &&
                <PageHeader
                    rows={[
                        [{ title: translate('resources.heading_messages.device_name'), message: _deviceName }, { title: translate('resources.heading_messages.device_id'), message: deviceSN }]
                    ]}
                    isSmall={isMobile}
                />
            }

            <List
                basePath={"locations/{id}/history"}
                actions={!isMobile ? <LocationHistoryActions recordId={id} isMobile={isMobile} /> : <div />}
                filters={<div />}
                filter={{
                    names: 'location',
                    device_ids: id,
                }}
                filterDefaultValues={{ ignore_pagination: true }}
                resource="location_events"
                sort={{ field: 'timestamp', order: 'DESC' }}
                pagination={false}
                disableSyncWithLocation
                perPage={5}
                sx={listMapCommonStyle({ theme, isMobile: isMobile, noActions: isMobile })}
            >

                <LocationsMap
                    history={true}
                    MenuCustomListItem={MenuCustomListItem}
                    MenuCustomListSubheader={MenuCustomListSubheader}
                    translate={translate}
                    allowRouting={true}
                    enablePdfReport={true}
                    pdfReportType={PDF_REPORT_LOCATION_HISTORY}
                    latKey={"latitude"}
                    longKey={"longitude"}
                    timestampKey={"timestamp"}
                    altKey={"altitude"}
                    accuracyKey={"accuracy"}
                    formattedAddressKey={"formatted_address"}
                    iconUrlKey={"image_url"}
                    nameKey={"event_id"}
                    isMobile={isMobile}
                    isListAsDialog={isMobile}
                    showLocationHistoryFiltersBtn={isMobile}
                    showDirectionsBtn={true}
                    recordId={id}
                    InfoDialogComponent={isMobile ? () => <PageHeader rows={[[{ title: translate('resources.heading_messages.device_name'), message: _deviceName }, { title: translate('resources.heading_messages.device_id'), message: deviceSN }]]} isSmall={isMobile} /> : null}
                    deviceName={_deviceName}
                    deviceSn={deviceSN}
                />

                <LoadingPopUp />
            </List>
        </Box>
    )
}

export default React.memo(LocationHistoryList);
